/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAllRegions() {
  const response = await $.soap({
    body: {
      getAllRegions: {
        $xmlns: 'http://dla.mil/ems/java/public'
      }
    },
    blueprintArrays: ['getAllRegionsResponse.tuple.old.getAllRegions.getAllRegions.GetAllRegionsResponse.LU_Region'],
    blueprint: {
      regions: [
        '$..GetAllRegionsResponse.LU_Region',
        {
          id: '$..ID',
          code: '$..RegionCode',
          name: '$..RegionName',
          isCONUS: '$..IsCONUS',
          regionGroupID: '$..RegionGroupID',
          isMFD: '$..IsMFD',
          isCONUSWide: '$..IsCONUSWide',
          isCONUSDesktop: '$..IsCONUSDesktop',
          isPRTNR: '$..IsPRTNR',
          isRelocation: '$..IsRelocation',
          isMaintenance: '$..IsMaintenance',
          isJapan: '$..IsJapan',
          isSpecialty: '$..IsSpecialty',
          isEuropeMiddleEast: '$..IsEuropeMiddleEast',
          isRegion1: '$..IsRegion1',
          isRegion2: '$..IsRegion2',
          isRegion3: '$..IsRegion3',
          isRegion4: '$..IsRegion4'
        }
      ]
    }
  });
  cleanUpResponse(response);
  return response.regions;
}
